var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShovelWithHeading = function SvgShovelWithHeading(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2927 18.7959H37.9348H33.6736H33.0014C32.8784 18.7959 32.7781 18.8908 32.7779 19.0082V28.7342H31.4206V29.1811H30.3098V19.9141H24.6151V25.6106H24.6133V26.56H24.6151V27.5094H24.6133V28.4589H24.6151V29.4083H24.6133V30.3577H24.6151V31.3071H24.6133V32.2565H24.6151V50.2955H26.3323V51.5101C26.3472 51.5436 27.5655 54.2165 36.1565 54.2165C36.1959 54.2165 36.2352 54.2148 36.2743 54.2147C36.3134 54.2148 36.3526 54.2165 36.392 54.2165C44.9831 54.2165 46.2014 51.5436 46.2163 51.5101V50.2955H47.3938V19.9141H41.6991V25.6106H38.8509V28.7342H38.5153V19.0082C38.5151 18.8909 38.4155 18.796 38.2927 18.7959Z",
    stroke: "#BDBDBD",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0123 28.958H40.6074V40.9869H32.0123V28.958Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 1.19632
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 19.54H30.3027V49.9215H24.6062V19.54Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6961 19.54H47.3926V49.9215H41.6961V19.54Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6961 19.54H47.3926V20.4895H41.6961V19.54Z",
    fill: "#414141"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 19.54H30.3027V20.4895H24.6062V19.54Z",
    fill: "#414141"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6961 34.731H47.3926V35.6804H41.6961V34.731Z",
    fill: "#414141"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 34.731H30.3027V35.6804H24.6062V34.731Z",
    fill: "#414141"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 38.5288H30.3027V39.4782H24.6062V38.5288Z",
    fill: "#414141"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 42.3262H30.3027V43.2756H24.6062V42.3262Z",
    fill: "#414141"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 46.124H30.3027V47.0734H24.6062V46.124Z",
    fill: "#414141"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6961 36.6299H47.3926V37.5793H41.6961V36.6299Z",
    fill: "#414141"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 36.6299H30.3027V37.5793H24.6062V36.6299Z",
    fill: "#414141"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 40.4272H30.3027V41.3767H24.6062V40.4272Z",
    fill: "#414141"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 44.2251H30.3027V45.1745H24.6062V44.2251Z",
    fill: "#414141"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 48.0229H30.3027V48.9724H24.6062V48.0229Z",
    fill: "#414141"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4937 38.5288H47.3926V39.4782H45.4937V38.5288Z",
    fill: "#414141"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4039 38.5288H30.3027V39.4782H28.4039V38.5288Z",
    fill: "#414141"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4937 40.4272H47.3926V41.3767H45.4937V40.4272Z",
    fill: "#414141"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4039 40.4272H30.3027V41.3767H28.4039V40.4272Z",
    fill: "#414141"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4937 42.3262H47.3926V43.2756H45.4937V42.3262Z",
    fill: "#414141"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4039 42.3262H30.3027V43.2756H28.4039V42.3262Z",
    fill: "#414141"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4937 44.2251H47.3926V45.1745H45.4937V44.2251Z",
    fill: "#414141"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4039 44.2251H30.3027V45.1745H28.4039V44.2251Z",
    fill: "#414141"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4937 46.124H47.3926V47.0734H45.4937V46.124Z",
    fill: "#414141"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4039 46.124H30.3027V47.0734H28.4039V46.124Z",
    fill: "#414141"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4937 48.0229H47.3926V48.9724H45.4937V48.0229Z",
    fill: "#414141"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4039 48.0229H30.3027V48.9724H28.4039V48.0229Z",
    fill: "#414141"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4937 27.1357H47.3926V28.0852H45.4937V27.1357Z",
    fill: "#414141"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.607 27.1357H26.5059V28.0852H24.607V27.1357Z",
    fill: "#414141"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.607 29.0342H26.5059V29.9836H24.607V29.0342Z",
    fill: "#414141"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.607 30.9331H26.5059V31.8825H24.607V30.9331Z",
    fill: "#414141"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4937 29.0342H47.3926V29.9836H45.4937V29.0342Z",
    fill: "#414141"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4039 29.0342H30.3027V29.9836H28.4039V29.0342Z",
    fill: "#414141"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4937 30.9331H47.3926V31.8825H45.4937V30.9331Z",
    fill: "#414141"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4039 30.9331H30.3027V31.8825H28.4039V30.9331Z",
    fill: "#414141"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6961 32.832H47.3926V33.7815H41.6961V32.832Z",
    fill: "#414141"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 32.832H30.3027V33.7815H24.6062V32.832Z",
    fill: "#414141"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6961 23.3379H47.3926V24.2873H41.6961V23.3379Z",
    fill: "#414141"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 23.3379H30.3027V24.2873H24.6062V23.3379Z",
    fill: "#414141"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4937 25.2368H47.3926V26.1862H45.4937V25.2368Z",
    fill: "#414141"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.607 25.2368H26.5059V26.1862H24.607V25.2368Z",
    fill: "#414141"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6961 21.439H47.3926V22.3884H41.6961V21.439Z",
    fill: "#414141"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6062 21.439H30.3027V22.3884H24.6062V21.439Z",
    fill: "#414141"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2656 28.3562V19.603H37.3315V28.3562L38.3535 33.0174V34.8217H33.0863V33.0925L34.2656 28.3562Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.19632
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1748 34.5215C37.4893 35.4236 38.1968 37.6791 37.0176 38.9571",
    stroke: "black",
    strokeWidth: 0.747699
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6865 34.5215C34.3721 35.4236 33.6645 37.6791 34.8438 38.9571",
    stroke: "black",
    strokeWidth: 0.747699
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7739 30.1727C32.7739 30.2903 32.8737 30.3858 32.9969 30.3858H33.7303C33.8533 30.3858 33.9531 30.2903 33.9531 30.1727V23.3815C33.9531 23.2639 33.8533 23.1685 33.7303 23.1685H32.9969C32.8737 23.1685 32.7739 23.2639 32.7739 23.3815V30.1727Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3325 30.1727C37.3325 30.2903 37.4323 30.3858 37.5555 30.3858H38.2889C38.4119 30.3858 38.5117 30.2903 38.5117 30.1727V23.3815C38.5117 23.2639 38.4119 23.1685 38.2889 23.1685H37.5555C37.4323 23.1685 37.3325 23.2639 37.3325 23.3815V30.1727Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0977 38.4663V45.6493H26.5082V28.937H32.6983V38.28L46.0977 38.4663Z",
    fill: "#F9BA15"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1362 38.2799H32.7718V28.8071H26.3254V51.1357C26.3254 51.1357 27.5046 53.8422 36.1522 53.8422C44.7998 53.8422 46.2148 51.1357 46.2148 51.1357L46.1362 38.2799Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.4954
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4828 34.5337C26.4828 34.6512 26.5827 34.7467 26.7058 34.7467H32.1561C32.2791 34.7467 32.3789 34.6512 32.3789 34.5337V33.2306C32.3789 33.1131 32.2791 33.0176 32.1561 33.0176H26.7058C26.5827 33.0176 26.4828 33.1131 26.4828 33.2306V34.5337Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7973 38.6686C26.7973 38.7862 26.8971 38.8817 27.0202 38.8817H32.1561C32.2791 38.8817 32.3789 38.7862 32.3789 38.6686V38.1926C32.3789 38.075 32.2791 37.9795 32.1561 37.9795H27.0202C26.8971 37.9795 26.7973 38.075 26.7973 38.1926V38.6686Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9023 49.5571H26.5632",
    stroke: "black",
    strokeWidth: 0.747699
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8499 25.2368H46.4453V38.5287H38.8499V25.2368Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7996 28.5596H45.4961V34.0979H39.7996V28.5596Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7996 26.3442H45.4961V27.4519H39.7996V26.3442Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShovelWithHeading);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "shovel-with-heading.0cd4b87fdb3a08b2d91edf1be18967dc.svg";